module.exports = __webpack_public_path__ + "media/research2.a6148cba.mp4";